export default __webpack_public_path__ + "static/media/Money.68ce2828.svg";